import { FetchInterceptor } from "src/app/helpers/Index";
import { environment } from "src/environments/environment";

const endpoint = "Allocation";
const json = { "Content-Type": "application/json" };
const url = (path: string) => `${environment.server.apiURL}/${endpoint}${path}`;

/** Matches OrderProductTypeEnum. */
export const AllocationParent = { Fixture: 0, Event: 10 };

/**
 * Allocations: private, capped, code-gated ticket pools.
 * Not an away-ticket feature — the away allocation is one row among many.
 */
export const AllocationService = {
	endpoint,
	status: async () => await FetchInterceptor(url("/Status"), {headers: json, method: "GET"}),
	getForParent: async (parentType: number, parentId: number) =>
		await FetchInterceptor(url(`/${parentType}/${parentId}`), {headers: json, method: "GET"}),
	add: async (parentType: number, parentId: number, data: any) =>
		await FetchInterceptor(url(`/${parentType}/${parentId}`), {body: JSON.stringify(data), headers: json, method: "POST"}),
	update: async (id: number, data: any) =>
		await FetchInterceptor(url(`/${id}`), {body: JSON.stringify(data), headers: json, method: "POST"}),
	remove: async (id: number) => await FetchInterceptor(url(`/${id}`), {headers: json, method: "DELETE"})
}
